import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';

enum EmailStatus {
  success = 'true',
  failed = 'false',
}

@Component({
  selector: 'app-succes-failed-email',
  templateUrl: './succes-failed-email.component.html',
  styleUrls: ['./succes-failed-email.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuccesFailedEmailComponent implements OnInit {
  response: EmailStatus | undefined;
  token: string = '';
  emailSuccess: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params: Params) => {
      this.response = params['status'];
      this.token = params['token'];
    });

    if (!this.response || !this.token) {
      this.goToHomeFromError();
    }

    this.emailSuccess = this.response === EmailStatus.success;
  }

  goToAnotherResource() {
    this.router.navigate(['/home'], { queryParams: { reintent: true, success: true } });
  }

  goToHomeFromError() {
    this.router.navigate(['']);
  }

  goToReintent() {
    this.router.navigate(['/home'], { queryParams: { reintent: true, success: false } });
  }
}
